import {EVENT_LOG_TYPE} from '@/api/log/constants';
import {convertKeysToSnakeCase, objectToQueryString} from '@/utils';
import {ClickLogParams, InflowPathLogParams} from '@/api/log/type';
import {LOGEVENTCommonApi} from '@/api/channel/common';

// Note. 로그 발송은 Fire and Forget으로, 리액트 쿼리 등으로 별도 관리하지 않습니다.

/**
 * 플레이어 진입 (inflow_path) 로그를 발송합니다.
 */
export const postInflowPathLog = (params: InflowPathLogParams) => {
  const {sendData: sendDataParams, ...rest} = params;

  /** 객체 -> 문자열 변환 */
  const sendData = objectToQueryString(convertKeysToSnakeCase(sendDataParams));

  return LOGEVENTCommonApi.post(
    '/set_log_api.php',
    convertKeysToSnakeCase({
      sztype: EVENT_LOG_TYPE.INFLOW_PATH,
      sendData,
      ...rest,
    }),
    {},
  );
};

export const channelClickLog = (params: ClickLogParams) => {
  return LOGEVENTCommonApi.post('/set_log_api.php', params, {});
};
